export default {
  // sys admin - organizations list header
  'organizations.title': 'Organizations',
  'organizations.createOrganizationBtn': 'Create organization',

  // organizations table column headers
  'organizations.tableHeader.name': 'Name',
  'organizations.tableHeader.organizationKey': 'Organization key',
  'organizations.tableHeader.status': 'Status',
  'organizations.tableHeader.type': 'Type',
  'organizations.tableHeader.subType': 'Subtype',
  'organizations.tableHeader.creationDate': 'Creation date',

  'organizations.createEditDialog.successCreateTextCreate':
    'Organization was created successfully.',
  'organizations.createEditDialog.successEditTextCreate': 'Organization was updated successfully.',
  'organizations.createEditDialog.organizationKeyLabel': 'Organization key',
  'organizations.createEditDialog.organizationKeyPlaceholder': 'Enter organization key',

  // organizations datasets dialog
  'organizations.datasetsDialog.title': 'Manage datasets',
  'organizations.datasetsDialog.subTitle': 'Datasets',
  'organizations.datasetsDialog.leftTitle': 'Unavailable',
  'organizations.datasetsDialog.rightTitle': 'Available',
  'organizations.datasetsDialog.description':
    'Select which datasets will be available to all users of this organization.',
  'organizations.datasetsDialog.saveButton': 'Save changes',
  'organizations.datasetsDialog.confirmChanges': 'Confirm changes',
  'organizations.createEditDialog.savingChangesBtnLabel': 'Saving changes',

  // organizations datasets dialog confirmation step
  'organizations.datasetsDialog.confirmationStep.title': 'Confirm changes',
  'organizations.datasetsDialog.confirmationStep.availableDataSets': 'Available datasets:',
  'organizations.datasetsDialog.confirmationStep.madeAvailableDataSets': 'Datasets made available:',
  'organizations.datasetsDialog.confirmationStep.madeUnavailableDataSets':
    'Datasets made unavailable:',
  'organizations.datasetsDialog.confirmationStep.noChange': 'No Change',
  'organizations.datasetsDialog.confirmationStep.successText':
    'Available datasets were updated successfully.',
  'organizations.createEditDialog.organizationNameInvalidCharactersError':
    "Organization name must only contain letters, numbers, '_' and '-'",
  'organizations.createEditDialog.organizationNameStartEndCharactersError':
    'Organization name must start and end with a letter or number',
};
